import * as React from 'react';
const MainCore = (props) => {
    const { children, className, components: { InputProvider, CookieConsentProvider, HeaderProvider }, consent, consentEnabled, consentContent, } = props;
    const BEM = () => {
        const classArray = ['main'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(CookieConsentProvider, { consent: consent, enabled: consentEnabled, content: consentContent },
        React.createElement(InputProvider, null,
            React.createElement(HeaderProvider, null,
                React.createElement("div", { className: BEM() },
                    React.createElement("div", { className: "main__inner" }, children))))));
};
export { MainCore as default };
